import React from 'react'
import { useNavigate } from 'react-router-dom'
import klalogo from '../Assets/kla-logo.png'
import SearchBarCommon from './SearchBarCommon'
function Logo_path({ AdminOrHome, Directory }) {
  const navigate = useNavigate()
  return (
    <div className='w-full h-full flex flex-row justify-between gap-1' style={{ fontFamily: "Ropa Sans" }}>
      <div className=' md:mt-2 mt-3 flex items-center' onClick={e => navigate('/')} style={{ cursor: 'pointer' }}>
        <img className='sm:w-20 w-12 sm:h-16 h-8 pl-1' src={klalogo} alt="Kerala Govt" /></div>

      <SearchBarCommon />



      <div className='md:flex hidden flex-row items-center'>
        <div onClick={e => AdminOrHome == 'Home' ? navigate('/') : navigate('/admin')} style={{ cursor: 'pointer' }} className='hover:text-blue-600 transform duration-200 ease-in-out'><i className="fa-solid fa-chevron-left me-2"></i>{AdminOrHome} /  </div>
        <div><p>{Directory}</p></div>
      </div>

    </div>
  )
}

export default Logo_path